var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_17590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_17590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H0.5V24H24.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_17590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5C13.1922 15.5 13.8689 15.2947 14.4445 14.9101C15.0201 14.5256 15.4687 13.9789 15.7336 13.3394C15.9985 12.6999 16.0678 11.9961 15.9327 11.3172C15.7977 10.6383 15.4644 10.0146 14.9749 9.52513C14.4854 9.03564 13.8618 8.7023 13.1828 8.56725C12.5039 8.4322 11.8001 8.50152 11.1606 8.76642C10.5211 9.03133 9.97444 9.47993 9.58986 10.0555C9.20527 10.6311 9 11.3078 9 12C9 12.9283 9.36875 13.8185 10.0251 14.4749C10.6815 15.1313 11.5717 15.5 12.5 15.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.529C21.5 18.5 19.5 21 12.5 21C5.5 21 3.5 19 3.5 12C3.5 5.5 5.5 3 12.5 3C20 3 21.5 5.5 21.5 12.529Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5C17.0989 7.5 17.1956 7.47068 17.2778 7.41574C17.36 7.36079 17.4241 7.28271 17.4619 7.19134C17.4998 7.09998 17.5097 6.99945 17.4904 6.90246C17.4711 6.80546 17.4235 6.71637 17.3536 6.64645C17.2836 6.57652 17.1945 6.5289 17.0975 6.50961C17.0006 6.49031 16.9 6.50022 16.8087 6.53806C16.7173 6.5759 16.6392 6.63999 16.5843 6.72221C16.5293 6.80444 16.5 6.90111 16.5 7C16.5 7.13261 16.5527 7.25979 16.6464 7.35355C16.7402 7.44732 16.8674 7.5 17 7.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_17590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon2);
export default __webpack_public_path__ + "static/media/instagram-icon-2.328556d9d67db5d7493edfcf854343a3.svg";
export { ForwardRef as ReactComponent };